export const FullDealEntryPointBannerTexts = {
  title: 'Подберём займ',
  badgeTitle: 'ЕСТЬ АКТИВНАЯ ЗАЯВКА',
  badgeTitleWithTime: 'за 5 минут',
} as const;
